<button class="btn" [ngClass]="small?'smallHelp':'helpBtn'" data-toggle="modal"
  [attr.data-target]="'#' + modalId"></button>
<div class="modal fade" tabindex="-1" role="dialog" [id]="modalId" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="header1"> {{title}}:</h1>
        <p style="text-align: justify; white-space: pre-line;">{{msg}}</p>
      </div>
      <div class="modal-footer simple-footer">
        <button data-dismiss="modal">بستن</button>
      </div>
    </div>
  </div>
</div>
